const TWILIO_TEMPLATE_VERSIONS = {
    LEGACY_TEMPLATE: 'LegacyTemplate',
    CONTENT_TEMPLATE_BUILDER: 'ContentTemplateBuilder',
    META_TEMPLATE: 'MetaTemplate',
};

const TWILIO_CONTENT_VARIABLES_TYPES = {
    DEFAULT: 'default',
    APPOINTMENT: 'appointment',
    DOCUMENTATION: 'documentation',
};

const TEMPLATE_LANGUAGES = {
    ENGLISH_US: 'en_US',
    SPANISH_MX: 'es_MX',
};

const TEMPLATE_LOGIC_TYPES = {
    LEGACY: 'legacy',
    NEW: 'new',
    SYSTEM: 'system',
} as const;

const TEMPLATE_PROVIDERS = {
    TWILIO: 'twilio',
    META: 'meta',
} as const;

export {
    TWILIO_TEMPLATE_VERSIONS,
    TWILIO_CONTENT_VARIABLES_TYPES,
    TEMPLATE_LANGUAGES,
    TEMPLATE_LOGIC_TYPES,
    TEMPLATE_PROVIDERS,
};
